var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "base-map-card" }, [
    _c(
      "div",
      { staticClass: "base-map-card__image" },
      [
        _c(_setup.MapImage, {
          attrs: { src: _setup.current_baseMaps.thumbnail },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "base-map-card__content" }, [
      _c("div", [
        _vm._v(
          " " + _vm._s(_vm.title || _setup.trans("map.basemap.title")) + " "
        ),
      ]),
      _c(
        "div",
        [
          _c(_setup.inputSelect, {
            attrs: {
              value: _setup.current_baseMaps,
              items: _setup.c_baseMaps,
              returnObject: "",
              itemText: "title",
              itemValue: "id",
            },
            on: { input: _setup.onChangeBaseMap },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }